// ═══════════════════════════════════════════════
//   ALIEN MEMORY — minigame
// ═══════════════════════════════════════════════
//
// Objective:   Match all 6 alien pairs by flipping cards two at a time
//              before the timer runs out.
// Type:        memory
// Description: Click cards to flip; matched pairs stay revealed. Faster
//              completion grants a time-bonus. Round ends when all pairs
//              are found or the timer expires. Reward scales with pairs
//              + remaining seconds.
// Tunables:    GAME_MEMORY in data.js.

const {ALIENS, ALIEN_KEYS, canvas, ctx, claimGameReward, GAME_MEMORY, addCleanup, showGameOver} = window;

window.memCards   = [];
window.memFlipped = [];
window.memMatched = 0;
window.memLock    = false;

function startMemory() {
    // Resize canvas to its actual CSS display size so alien images render at
    // native resolution instead of being upscaled (blurry) by CSS.
    const rect = canvas.getBoundingClientRect();
    if (rect.width > 0) {
        canvas.width  = Math.round(rect.width);
        canvas.height = Math.round(rect.height);
    }

    window.memMatched = 0;
    window.memFlipped = [];
    window.memLock = false;
    window.gameTimer = GAME_MEMORY.timer;
    window.gameRunning = true;
    document.getElementById('mg-timer').textContent = GAME_MEMORY.timer + 's';
    const pairs = [...ALIEN_KEYS.slice(0, 6), ...ALIEN_KEYS.slice(0, 6)];
    window.memCards = pairs.sort(() => Math.random() - .5).map((k, i) => ({
        id: i,
        alienId: k,
        flipped: false,
        matched: false
    }));
    // 3 cols × 4 rows — much bigger cards than before
    const cols = 3, rows = 4, padX = 5, padY = 4, gapX = 5, gapY = 4;
    const cardW = Math.floor((canvas.width - 2 * padX - (cols - 1) * gapX) / cols);   // ≈114px
    const cardH = Math.floor((canvas.height - 2 * padY - (rows - 1) * gapY) / rows);  // ≈75px
    window.memCards.forEach((c, i) => {
        c.x = padX + (i % cols) * (cardW + gapX);
        c.y = padY + Math.floor(i / cols) * (cardH + gapY);
        c.w = cardW;
        c.h = cardH;
    });
    window.timerInterval = setInterval(() => {
        window.gameTimer--;
        document.getElementById('mg-timer').textContent = window.gameTimer + 's';
        if (window.gameTimer <= 0) endMemory();
    }, 1000);
    addCleanup(() => clearInterval(window.timerInterval));

    canvas.addEventListener('click', memClick);
    addCleanup(() => canvas.removeEventListener('click', memClick));
    addCleanup(() => { canvas.width = 364; canvas.height = 320; });

    const imgs = {};
    ALIEN_KEYS.forEach(k => {
        const img = new Image();
        img.src = ALIENS[k].img;
        imgs[k] = img;
    });
    window.memCards._imgs = imgs;
    drawMemory();
}

function drawMemory() {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.fillStyle = '#f0e6ff';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    window.memCards.forEach(c => {
        // shadow
        ctx.fillStyle = 'rgba(0,0,0,0.13)';
        ctx.beginPath();
        ctx.roundRect(c.x + 3, c.y + 3, c.w, c.h, 8);
        ctx.fill();
        // card face
        if (c.matched) {
            ctx.fillStyle = '#a8e063';
            ctx.strokeStyle = '#1a0010';
        } else if (c.flipped) {
            ctx.fillStyle = 'white';
            ctx.strokeStyle = '#f72585';
        } else {
            ctx.fillStyle = '#f72585';
            ctx.strokeStyle = '#1a0010';
        }
        ctx.lineWidth = 2.5;
        ctx.beginPath();
        ctx.roundRect(c.x, c.y, c.w, c.h, 8);
        ctx.fill();
        ctx.stroke();
        if (c.flipped || c.matched) {
            const img = window.memCards._imgs[c.alienId];
            if (img && img.complete && img.naturalWidth > 0) {
                // contain-fit with small inset so image fills the card properly
                const inset = 5;
                const dw = c.w - inset * 2, dh = c.h - inset * 2;
                const ratio = Math.min(dw / img.naturalWidth, dh / img.naturalHeight);
                const iw = img.naturalWidth * ratio, ih = img.naturalHeight * ratio;
                ctx.drawImage(img, c.x + inset + (dw - iw) / 2, c.y + inset + (dh - ih) / 2, iw, ih);
            } else {
                ctx.font = '36px serif';
                ctx.textAlign = 'center';
                ctx.fillStyle = '#333';
                ctx.fillText('👾', c.x + c.w / 2, c.y + c.h / 2 + 12);
            }
        } else {
            // back of card — large "?" scaled to card height
            ctx.font = `bold ${Math.floor(c.h * 0.52)}px sans-serif`;
            ctx.fillStyle = 'rgba(255,255,255,0.38)';
            ctx.textAlign = 'center';
            ctx.fillText('?', c.x + c.w / 2, c.y + c.h * 0.68);
        }
    });
}

function memClick(e) {
    if (window.memLock || !window.gameRunning) return;
    const {x: mx, y: my} = canvasPos(e);
    const card = window.memCards.find(c => !c.flipped && !c.matched && mx >= c.x && mx <= c.x + c.w && my >= c.y && my <= c.y + c.h);
    if (!card) return;
    card.flipped = true;
    window.memFlipped.push(card);
    SFX.play('click');
    drawMemory();
    if (window.memFlipped.length === 2) {
        window.memLock = true;
        setTimeout(() => {
            if (window.memFlipped[0].alienId === window.memFlipped[1].alienId) {
                window.memFlipped[0].matched = window.memFlipped[1].matched = true;
                window.memMatched++;
                if (window.memMatched === 6) {
                    endMemory();
                } else {
                    SFX.play('pts');
                }
            } else {
                window.memFlipped[0].flipped = window.memFlipped[1].flipped = false;
                SFX.play('error');
            }
            window.memFlipped = [];
            window.memLock = false;
            drawMemory();
        }, 800);
    }
}

function endMemory() {
    window.gameRunning = false;
    SFX.play(window.memMatched === 6 ? 'win' : 'gameover');
    if (window.memMatched >= GAME_MEMORY.nickThreshold) window.unlockNick('mastermind');
    const base = window.memMatched * GAME_MEMORY.ptsPerPair;
    const timeBonus = window.memMatched === 6 ? Math.floor(window.gameTimer * GAME_MEMORY.timeBonusFactor) : 0;
    const score = base + timeBonus;
    const p = Math.min(GAME_MEMORY.rewardMax, score);
    showGameOver(claimGameReward('memory', score, p));
}

window.startMemory = startMemory;
window.drawMemory = drawMemory;
window.memClick = memClick;
window.endMemory = endMemory;
